<template>
  <div>
    <div v-if="!isAuthenticationGranted">
      <!-- nic nezobrazit -->
    </div>
    <div v-if="isAuthenticationGranted">
      <gov-button v-if="!isBusy" :wcag-label="$t('portal.page-title.cart')" variant="primary" type="solid" size="m" hoverable id="gov-button-cart" class="gov-button-cart" @gov-click="cartClickHandler">
        <span class="material-icons-outlined" style="font-size: 16px; padding-top: 2px">shopping_cart</span>
        {{ this.$utils.localCurr(this.$store.state.cartSum) }}
      </gov-button>
    </div>
  </div>
</template>

<script>
import { eventBus } from "@/main";

export default {
  name: "CartControl",
  data() {
    return {
      isAuthenticationGranted: null,
      isBusy: false,
    };
  },
  mounted() {
    this.isBusy = true;
    this.refreshAuthenticationStatus();

    // Listen for authentication change events
    eventBus.$on('auth-changed', () => {
      console.log('Autorizuji kosik');
      this.refreshAuthenticationStatus();
    });
  },
  methods: {
    refreshAuthenticationStatus() {
      this.$backend.getAuthenticationStatus(response => {
        this.isAuthenticationGranted = response.data.authenticationGranted;
        this.isBusy = false;
      });
    },
    cartClickHandler() {
        this.$store.dispatch( "selectCart" );
        if (this.$router.currentRoute.name != "cart")
          this.$router.push( {name: "cart"} );
    },
  },
};
</script>
